import { logScrollDebug } from './session-debug';

export interface ScrollRestoreSnapshot {
  bottomOffset: number;
}

export function captureInitialRenderScrollRestoreSnapshot(
  element: HTMLElement,
  preserveViewport: boolean,
): ScrollRestoreSnapshot | null {
  if (!preserveViewport) {
    logScrollDebug('capture-scroll-snapshot:skip', {
      preserveViewport,
      scrollTop: element.scrollTop,
      scrollHeight: element.scrollHeight,
      clientHeight: element.clientHeight,
    });
    return null;
  }
  const snapshot = {
    bottomOffset: Math.max(0, element.scrollHeight - element.scrollTop),
  };
  logScrollDebug('capture-scroll-snapshot', {
    preserveViewport,
    scrollTop: element.scrollTop,
    scrollHeight: element.scrollHeight,
    clientHeight: element.clientHeight,
    bottomOffset: snapshot.bottomOffset,
  });
  return snapshot;
}

export function restoreInitialRenderScrollPosition(
  element: HTMLElement,
  snapshot: ScrollRestoreSnapshot | null,
): void {
  if (!snapshot) {
    element.scrollTop = element.scrollHeight;
    logScrollDebug('restore-scroll-position:bottom', {
      scrollTop: element.scrollTop,
      scrollHeight: element.scrollHeight,
      clientHeight: element.clientHeight,
    });
    return;
  }
  element.scrollTop = Math.max(0, element.scrollHeight - snapshot.bottomOffset);
  logScrollDebug('restore-scroll-position:preserved', {
    scrollTop: element.scrollTop,
    scrollHeight: element.scrollHeight,
    clientHeight: element.clientHeight,
    bottomOffset: snapshot.bottomOffset,
  });
}
